// @ts-nocheck
 
 


import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../API/axiosNeatex';

// Helper function to create async thunks
const createLookupThunk = (name, endpoint, lookupType) => 
  createAsyncThunk(`Lookup/${name}`, async (_, thunkAPI) => {
    const { rejectWithValue, getState } = thunkAPI;
    // const cachedData = getState().Lookup[lookupType];
    // if (cachedData?.length > 0) {
    //   return cachedData;
    // }
    try {
      const { data } = await ntxAPI.get(endpoint);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

// Helper function to generate extraReducers
const generateExtraReducers = (builder, thunk, stateKey) => {
  builder
    .addCase(thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.loading = false;
      state[stateKey] = action.payload;
    })
    .addCase(thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
};

// Define all thunks using the helper function
export const getTITLE = createLookupThunk('getTITLE', 'Lookup/GetByTypes?LookupTypes=TITLE', 'TITLE');
export const getSex = createLookupThunk('getSex', 'Lookup/GetByTypes?LookupTypes=SEX', 'SEX');
export const getMarStatus = createLookupThunk('getMarStatus', 'Lookup/GetByTypes?LookupTypes=MAR_STATUS', 'MAR_STATUS');
export const getNationality = createLookupThunk('getNationality', 'Lookup/GetByTypes?LookupTypes=NATIONALITY', 'NATIONALITY');
export const getOrgType = createLookupThunk('getOrgType', 'Lookup/GetByTypes?LookupTypes=ORG_TYPE', 'ORG_TYPE');
export const getOrgClass = createLookupThunk('getOrgClass', 'Lookup/GetByTypes?LookupTypes=ORG_CLASS', 'ORG_CLASS');
export const GetCurrency = createLookupThunk('GetCurrency', 'NtxSetting/GetCurrencyList', 'Currency');
export const GetModule = createLookupThunk('GetModule', 'NtxSetting/GetModuleList', 'Module');
export const GetTableData = createLookupThunk('GetTableData', 'NtxSetting/GetDataByTabelId', 'TableDataList');
export const getReligions = createLookupThunk('getReligions', 'Lookup/GetByTypes?LookupTypes=RELIGIONS', 'RELIGIONS');
export const getBanks = createLookupThunk('getBanks', 'NtxSetting/GetBankList', 'Banks');
export const GetFleetCategory = createLookupThunk('GetFleetCategory', 'Lookup/GetByTypes?LookupTypes=FLEET_CATEGORY', 'FleetCategory');
export const GetFleetFuelType = createLookupThunk('GetFleetFuelType', 'Lookup/GetByTypes?LookupTypes=FLEET_FUEL_TYPE', 'FleetFuelType');
export const GetFleetMotionVector = createLookupThunk('GetFleetMotionVector', 'Lookup/GetByTypes?LookupTypes=FLEET_MOTION_VECTOR', 'FleetMotionVector');
export const GetFleetRequestType = createLookupThunk('GetFleetRequestType', 'Lookup/GetByTypes?LookupTypes=FLEET_REQUEST_TYPE', 'FleetRequestType');
export const GetFleetInspectionType = createLookupThunk('GetFleetInspectionType', 'Lookup/GetByTypes?LookupTypes=FLEET_INSPECTION_TYPE', 'FleetInspectionType');
export const GetEngineStatues = createLookupThunk('GetEngineStatues', 'Lookup/GetByTypes?LookupTypes=ENGINE_STATUS', 'EngineStatues');
export const GetEquipmentStatus = createLookupThunk('GetEquipmentStatus', 'Lookup/GetByTypes?LookupTypes=EQUIPMENT_STATUS', 'EquipmentStatus');
export const GetLookupPRIORITY = createLookupThunk('GetLookupPRIORITY', 'Lookup/GetByTypes?LookupTypes=PRIORITY', 'PRIORITY');
export const GetLookupTaxType = createLookupThunk('GetLookupTaxType', 'Lookup/GetByTypes?LookupTypes=TAX_TYPE', 'TAX_TYPE');
export const GetUom_Class = createLookupThunk('GetUom_Class', 'Lookup/GetByTypes?LookupTypes=UOM_CLASS', 'UOM_CLASS');
export const GetItemType = createLookupThunk('GetItemType', 'Lookup/GetByTypes?LookupTypes=ITEM_TYPE', 'ITEM_TYPE');
export const GetCustomerType = createLookupThunk('GetCustomerType', 'Lookup/GetByTypes?LookupTypes=CUSTOMER_TYPE', 'CUSTOMER_TYPE');
export const GetInventoryTransactions = createLookupThunk('GetInventoryTransactions', 'Lookup/GetByTypes?LookupTypes=INVENTORY_TRANSACTIONS', 'INVENTORY_TRANSACTIONS');
export const GetDISCOUNTTYPE = createLookupThunk('GetDISCOUNTTYPE', 'Lookup/GetByTypes?LookupTypes=DISCOUNT_TYPE', 'DISCOUNT_TYPE');
export const GetREWARDS_TYPE = createLookupThunk('GetREWARDS_TYPE', 'Lookup/GetByTypes?LookupTypes=REWARDS_TYPE', 'REWARDS_TYPE');
export const get_POS_TYPE = createLookupThunk('get_POS_TYPE', 'Lookup/GetByTypes?LookupTypes=POS_TYPE', 'POS_TYPE');
export const Get_DEPRECIATION_METHOD = createLookupThunk('Get_DEPRECIATION_METHOD', 'Lookup/GetByTypes?LookupTypes=DEPRECIATION_METHOD', 'DEPRECIATION_METHOD');
export const Get_NEW_USED = createLookupThunk('Get_NEW_USED', 'Lookup/GetByTypes?LookupTypes=NEW_USED', 'NEW_USED');
export const Get_OWNED_LEASED = createLookupThunk('Get_OWNED_LEASED', 'Lookup/GetByTypes?LookupTypes=OWNED_LEASED', 'OWNED_LEASED');
export const Get_PEOPLE_TYPE = createLookupThunk('Get_PEOPLE_TYPE', 'Lookup/GetByTypes?LookupTypes=PEOPLE_TYPE', 'PEOPLE_TYPE');
export const Get_Permissions_Type = createLookupThunk('Get_Permissions_Type', 'Lookup/GetByTypes?LookupTypes=Permissions_Type', 'Permissions_Type');
export const Get_PEOPLE_CODE = createLookupThunk('Get_PEOPLE_CODE', 'Lookup/GetByTypes?LookupTypes=PEOPLE_CODE', 'PEOPLE_CODE');
export const Get_RetirementType = createLookupThunk('Get_RetirementType', 'Lookup/GetByTypes?LookupTypes=RetirementType', 'RetirementType');
export const Get_ExpenseDistribute = createLookupThunk('Get_ExpenseDistribute', 'Lookup/GetByTypes?LookupTypes=ExpenseDistribute', 'ExpenseDistribute');
export const Get_TaxCategory = createLookupThunk('Get_TaxCategory', 'Lookup/GetByTypes?LookupTypes=TaxCategory', 'TaxCategory');
export const Get_InventoryCountingTypes = createLookupThunk('Get_InventoryCountingTypes', 'Lookup/GetByTypes?LookupTypes=InventoryCountingTypes', 'InventoryCountingTypes');
export const Get_TasksStatus = createLookupThunk('Get_TasksStatus', 'Lookup/GetByTypes?LookupTypes=TasksStatus', 'TasksStatus');
export const Get_TaskDependenciesType = createLookupThunk('Get_TaskDependenciesType', 'Lookup/GetByTypes?LookupTypes=TaskDependenciesType', 'TaskDependenciesType');
export const Get_PerContractType= createLookupThunk('Get_PerContractType', 'Lookup/GetByTypes?LookupTypes=PerContractType', 'PerContractType');
export const Get_PROJECT_TYPE= createLookupThunk('Get_PROJECT_TYPE', 'Lookup/GetByTypes?LookupTypes=PROJECT_TYPE', 'PROJECT_TYPE');
export const Get_DELIVERY_MODEL= createLookupThunk('Get_DELIVERY_MODEL', 'Lookup/GetByTypes?LookupTypes=DELIVERY_MODEL', 'DELIVERY_MODEL');
export const Get_COST_SOURCE_TYPE= createLookupThunk('Get_COST_SOURCE_TYPE', 'Lookup/GetByTypes?LookupTypes=COST_SOURCE_TYPE', 'COST_SOURCE_TYPE');

const initialState = {
  TITLE: [],
  SEX: [],
  MAR_STATUS: [],
  NATIONALITY: [],
  ORG_TYPE: [],
  ORG_CLASS: [],
  Currency: [],
  Module: [],
  TableDataList: [],
  Banks: [],
  RELIGIONS: [],
  PEOPLE_TYPE: [],
  FleetCategory: [],
  FleetFuelType: [],
  FleetMotionVector: [],
  FleetRequestType: [],
  FleetInspectionType: [],
  EngineStatues: [],
  EquipmentStatus: [],
  PRIORITY: [],
  TAX_TYPE: [],
  UOM_CLASS: [],
  ITEM_TYPE: [],
  CUSTOMER_TYPE: [],
  INVENTORY_TRANSACTIONS: [],
  DISCOUNT_TYPE: [],
  REWARDS_TYPE: [],
  POS_TYPE: [],
  DEPRECIATION_METHOD: [],
  NEW_USED: [],
  OWNED_LEASED: [],
  Permissions_Type: [],
  PEOPLE_CODE: [],
  RetirementType: [],
  ExpenseDistribute: [],
  TaxCategory: [],
  InventoryCountingTypes: [],
  TasksStatus: [],
  TaskDependenciesType: [],
  PerContractType: [],
  PROJECT_TYPE: [],
  DELIVERY_MODEL: [],
  COST_SOURCE_TYPE: [],

  loading: false,
  NationalityLoading: false,
  error: null,
};

const lookupSlice = createSlice({
  name: 'Lookup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    generateExtraReducers(builder, getTITLE, 'TITLE');
    generateExtraReducers(builder, getSex, 'SEX');
    generateExtraReducers(builder, getMarStatus, 'MAR_STATUS');
    generateExtraReducers(builder, getNationality, 'NATIONALITY');
    generateExtraReducers(builder, getOrgType, 'ORG_TYPE');
    generateExtraReducers(builder, getOrgClass, 'ORG_CLASS');
    generateExtraReducers(builder, GetCurrency, 'Currency');
    generateExtraReducers(builder, GetModule, 'Module');
    generateExtraReducers(builder, GetTableData, 'TableDataList');
    generateExtraReducers(builder, getReligions, 'RELIGIONS');
    generateExtraReducers(builder, getBanks, 'Banks');
    generateExtraReducers(builder, GetFleetCategory, 'FleetCategory');
    generateExtraReducers(builder, GetFleetFuelType, 'FleetFuelType');
    generateExtraReducers(builder, GetFleetMotionVector, 'FleetMotionVector');
    generateExtraReducers(builder, GetFleetRequestType, 'FleetRequestType');
    generateExtraReducers(builder, GetFleetInspectionType, 'FleetInspectionType');
    generateExtraReducers(builder, GetEngineStatues, 'EngineStatues');
    generateExtraReducers(builder, GetEquipmentStatus, 'EquipmentStatus');
    generateExtraReducers(builder, GetLookupPRIORITY, 'PRIORITY');
    generateExtraReducers(builder, GetLookupTaxType, 'TAX_TYPE');
    generateExtraReducers(builder, GetUom_Class, 'UOM_CLASS');
    generateExtraReducers(builder, GetItemType, 'ITEM_TYPE');
    generateExtraReducers(builder, GetCustomerType, 'CUSTOMER_TYPE');
    generateExtraReducers(builder, GetInventoryTransactions, 'INVENTORY_TRANSACTIONS');
    generateExtraReducers(builder, GetDISCOUNTTYPE, 'DISCOUNT_TYPE');
    generateExtraReducers(builder, GetREWARDS_TYPE, 'REWARDS_TYPE');
    generateExtraReducers(builder, get_POS_TYPE, 'POS_TYPE');
    generateExtraReducers(builder, Get_DEPRECIATION_METHOD, 'DEPRECIATION_METHOD');
    generateExtraReducers(builder, Get_NEW_USED, 'NEW_USED');
    generateExtraReducers(builder, Get_OWNED_LEASED, 'OWNED_LEASED');
    generateExtraReducers(builder, Get_PEOPLE_TYPE, 'PEOPLE_TYPE');
    generateExtraReducers(builder, Get_Permissions_Type, 'Permissions_Type');
    generateExtraReducers(builder, Get_PEOPLE_CODE, 'PEOPLE_CODE');
    generateExtraReducers(builder, Get_RetirementType, 'RetirementType');
    generateExtraReducers(builder, Get_ExpenseDistribute, 'ExpenseDistribute');
    generateExtraReducers(builder, Get_TaxCategory, 'TaxCategory');
    generateExtraReducers(builder, Get_InventoryCountingTypes, 'InventoryCountingTypes');
    generateExtraReducers(builder, Get_TasksStatus, 'TasksStatus');
    generateExtraReducers(builder, Get_TaskDependenciesType, 'TaskDependenciesType');
    generateExtraReducers(builder, Get_PerContractType, 'PerContractType');
    generateExtraReducers(builder, Get_PROJECT_TYPE, 'PROJECT_TYPE');
    generateExtraReducers(builder, Get_DELIVERY_MODEL, 'DELIVERY_MODEL');
    generateExtraReducers(builder, Get_COST_SOURCE_TYPE, 'COST_SOURCE_TYPE');
  },
});

export default lookupSlice.reducer;